import SuperagentBase from '../shared/superagent-base';

export default class GoogleAPI extends SuperagentBase {
    sendEmail(token, email) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/GoogleApi/email`)
                .set('api-key', 'Bearer ' + token)
                .send(email)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    createCalendarEvent(token, event) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/GoogleAPI/calendarEvent`)
                .retry(3, [1000, 3000, 5000])
                .set('api-key', 'Bearer ' + token)
                .send(event)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    batchCreateCalendarEvents(token, events) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/GoogleAPI/batch/calendarEvent/create`)
                .set('api-key', 'Bearer ' + token)
                .send(events)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    batchDeleteCalendarEvents(token, eventIds) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/GoogleAPI/batch/calendarEvent/delete`)
                .set('api-key', 'Bearer ' + token)
                .send(eventIds)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    deleteCalendarEvent(token, eventId) {
        return new Promise((resolve, reject) => {
            this.request
                .del(`api/GoogleAPI/calendarEvent/${eventId}`)
                .retry(3)
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    //Ignore 410 - Event was already deleted
                    if (error && error.status === 410) {
                        resolve(res);
                    } else {
                        error ? reject(error) : resolve(res);
                    }
                });
        });
    }

    deleteCredential(token) {
        return new Promise((resolve, reject) => {
            this.request
                .delete('api/googleapi/credential/me')
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/resources/google-api-resource.js